import * as actionTypes from "../../actionLabels/index";

const initialState = {
  data: null,
  error: null,
  isApiCallInProgress: false,
  isExport: false
};

const buyerOutstandingPaymentDetailReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA:
      return {
        ...state,
        isApiCallInProgress: true
      };
    case actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isApiCallInProgress: false
      };
    case actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        isApiCallInProgress: false
      };
    case actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_API_CALL:
      return {
        ...state,
        isApiCallInProgress: action.payload
      };
    case actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_EXPORT_SUCCESS:
      return {
        ...state,
        isExport: true,
        data: action.payload,
        isApiCallInProgress: false
      };
    default:
      return state;
  }
};

export default buyerOutstandingPaymentDetailReportReducer;
